const checkListItemSubType = {
    NONE : -1,

    UNDERWRITING_AUTHORITY : 1,

    UNDERWRITING_AUTHORITY_APPROVED : 2

};

angular.module('gw-um-j2js')
    .constant('checkListItemSubType', checkListItemSubType);